import React from 'react';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles(() => ({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  innerContainer: {
    display: 'grid',
    gridTemplateColumns: '60% 40%',
    columnGap: 16,
    marginBottom: 16,
  },
}));

const ProductDetailMobileSkeleton = () => {
  const classes = useStyles();
  return (
    <Box className={classes.container}>
      <div>
        <Skeleton height={40} />
      </div>
      <div className={classes.innerContainer}>
        <Skeleton height={108} width={108} />
        <Skeleton height={173} width={157} />
      </div>
      <div>
        <Skeleton height={40} />
      </div>
    </Box>
  );
};

export default ProductDetailMobileSkeleton;
